function assertFunction(value, methodName, label) {
  if (typeof value !== 'function') {
    throw new Error(`[live/ports] ${label} is missing required method: ${methodName}`)
  }
}

export const RTC_SESSION_EVENT_TYPES = Object.freeze({
  participantsChanged: 'participants-changed',
  stateChanged: 'state-changed',
  error: 'error',
})

/**
 * Provider-neutral RTC session transport contract.
 *
 * @typedef {object} RtcSessionPort
 * @property {(config: object) => Promise<unknown>} join
 * @property {() => Promise<unknown>} leave
 * @property {(enabled: boolean) => Promise<unknown>} setLocalAudioEnabled
 * @property {(enabled: boolean) => Promise<unknown>} setLocalVideoEnabled
 * @property {(devices: object) => Promise<unknown>} setDevices
 * @property {() => Promise<unknown>} startScreenShare
 * @property {() => Promise<unknown>} stopScreenShare
 * @property {(listener: (event: object) => void) => () => void} subscribe
 */

/**
 * @param {unknown} value
 * @param {string} [label='RtcSessionPort']
 * @returns {RtcSessionPort}
 */
export function assertRtcSessionPort(value, label = 'RtcSessionPort') {
  assertFunction(value?.join, 'join', label)
  assertFunction(value?.leave, 'leave', label)
  assertFunction(value?.setLocalAudioEnabled, 'setLocalAudioEnabled', label)
  assertFunction(value?.setLocalVideoEnabled, 'setLocalVideoEnabled', label)
  assertFunction(value?.setDevices, 'setDevices', label)
  assertFunction(value?.startScreenShare, 'startScreenShare', label)
  assertFunction(value?.stopScreenShare, 'stopScreenShare', label)
  assertFunction(value?.subscribe, 'subscribe', label)

  return value
}
